import React from 'react';

interface VenereIconCleanProps {
  size?: number;
  className?: string;
  color?: string;
  onClick?: () => void;
}

export const VenereDisplay: React.FC<VenereIconCleanProps> = ({
  size = 24,
  className = '',
  color = 'currentColor',
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2000 2000"
      fill={color}
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path d="M1580.31,261.42h-263.78c-29.15,0-52.76,23.61-52.76,52.76s23.61,52.76,52.76,52.76h263.78c29.08,0,52.76,23.67,52.76,52.76v738.58c0,29.08-23.67,52.76-52.76,52.76H419.69c-29.08,0-52.76-23.67-52.76-52.76V419.69c0-29.08,23.67-52.76,52.76-52.76h685.82c29.15,0,52.76-23.61,52.76-52.76s-23.61-52.76-52.76-52.76H419.69c-87.25,0-158.27,71.02-158.27,158.27v738.58c0,87.25,71.02,158.27,158.27,158.27h354.45l-26.38,105.51h-11.54c-87.25,0-158.27,71.02-158.27,158.27v105.51c0,29.15,23.61,52.76,52.76,52.76h738.58c29.15,0,52.76-23.61,52.76-52.76v-105.51c0-87.25-71.02-158.27-158.27-158.27h-11.54l-26.38-105.51h354.45c87.25,0,158.27-71.02,158.27-158.27V419.69c0-87.25-71.02-158.27-158.27-158.27h0ZM1316.54,1580.31v52.76h-633.07v-52.76c0-29.08,23.67-52.76,52.76-52.76h527.56c29.08,0,52.76,23.67,52.76,52.76ZM1143.43,1422.04h-286.92l26.38-105.51h234.17l26.38,105.51ZM1156.29,882.17l60.6-117.38c9.1-17.54,27.17-28.55,46.89-28.55h158.27c29.15,0,52.76,23.61,52.76,52.76s-23.61,52.76-52.76,52.76h-126.09l-90.81,179.17c-8.9,17.21-26.58,31.85-45.96,31.85h-.92c-19.06,0-36.67-13.52-46.03-30.27l-165.46-296.29-112.04,195.25c-9.36,16.49-26.84,25.78-45.76,25.78h-211.02c-29.15,0-52.76-23.61-52.76-52.76s23.61-52.76,52.76-52.76h180.43l143.1-250.39c9.43-16.49,25.65-27.83,46.03-26.58,18.99.07,36.53,10.35,45.83,26.97l162.94,290.43Z"/>
    </svg>
  );
};

export default VenereDisplay; 